import caseOverviewHeaders from './caseOverviewHeaders';
import dataValidationHeaders from './dataValidationHeaders';
import aliquotOverviewHeaders from './aliquotOverviewHeaders';

export let reportsHeaders = {
  case_overview: caseOverviewHeaders,
  data_validation: dataValidationHeaders,
  aliquot_overview: aliquotOverviewHeaders,
};

export let buildReportMap = ({ report, type }) => (
  new Map(reportsHeaders[type].map(header => ([header, report[header]])))
);
